import { Icons } from '@nextiva/next-ui-components';
import { GridTileDef } from 'types/Launchpad';

export const TEST_ID = 'PlatformAdminUI-Launchpad';

export const QUERY_KEY = 'platform-admin-launchpad';

export const headerTitleCreator = (displayName = '') =>
  `Welcome, ${displayName}`;

export const HEADER_SUBTITLE_WITH_CONNECT_LICENSE =
  'Use this space as your home base to access all your business tools in one place';

export const HEADER_SUBTITLE_WITHOUT_CONNECT_LICENSE =
  'Discover a world of connected communication. Your communication, collaboration, and customer relationship management are all connected in a single, powerful platform. Use this space to get set up and start growing your business.';

export const BANNER_TITLE = 'Say "hello!" to the future of work.';

export const BANNER_SUBTITLE =
  'All of your communications, business contacts, and team collaboration in one place - no more app switching.';

export const GRID_TILE_ICON_FONT_SIZE = '24px';

export const DISABLED_TILE_TEXT = 'Request access from admin';

export const DEFAULT_GRID_TILE_DEF: GridTileDef = {
  actionHandler: null,
  actionLabel: '',
  id: '',
  isEnabled: false,
  content: null,
  disabledText: DISABLED_TILE_TEXT,
  icon: '',
  iconElement: null,
  title: '',
  titleColor: '',
};

export const USERS_GRID_TILE_DEF: GridTileDef = {
  actionHandler: null,
  actionLabel: 'Manage users',
  id: 'users',
  isEnabled: false,
  content: null,
  disabledText: DISABLED_TILE_TEXT,
  icon: Icons.user,
  iconElement: null,
  title: 'Users',
  titleColor: '',
};

export const TEAMS_GRID_TILE_DEF: GridTileDef = {
  actionHandler: null,
  actionLabel: 'Manage teams',
  id: 'teams',
  isEnabled: false,
  content: null,
  disabledText: DISABLED_TILE_TEXT,
  icon: Icons.team,
  iconElement: null,
  title: 'Teams',
  titleColor: '',
};

export const ROLES_GRID_TILE_DEF: GridTileDef = {
  actionHandler: null,
  actionLabel: 'Manage roles',
  id: 'roles',
  isEnabled: false,
  content: 'Access and permissions',
  disabledText: DISABLED_TILE_TEXT,
  icon: Icons.userShield,
  iconElement: null,
  title: 'Roles',
  titleColor: '',
};

export const CALL_FLOW_GRID_TILE_DEF: GridTileDef = {
  actionHandler: null,
  actionLabel: 'Manage call flows',
  id: 'callFlows',
  isEnabled: false,
  content: null,
  disabledText: DISABLED_TILE_TEXT,
  icon: Icons.callFlow,
  iconElement: null,
  title: 'Call flows',
  titleColor: '',
};

export const DATA_IMPORT_GRID_TILE_DEF: GridTileDef = {
  actionHandler: null,
  actionLabel: 'Import now',
  id: 'datamport',
  isEnabled: false,
  content: 'Users, devices, etc.',
  disabledText: DISABLED_TILE_TEXT,
  icon: Icons.fileUpload,
  iconElement: null,
  title: 'Data import',
  titleColor: '',
};

// Pulled in from launchpad-spa src/constants/permissionTypes.ts
export const PERMISSION_TYPES = {
  people: {
    resourceId: 'bbcb4260-ba62-4a50-961f-2fd8c31b9ca8',
    users: 'Manage Users',
    roles: 'Manage Roles & Permissions',
    teams: 'Manage Teams',
  },
  communications: {
    resourceId: '9ffc9ed7-1f60-4476-9fac-7a1b767ba1ad',
    voice: 'Manage Voice',
  },
  data: {
    resourceId: 'fc223034-b8f9-4ea2-8bb2-03a279a1ffa6',
    import: 'Import',
    export: 'Export',
  },
};

export const CONNECT_FEATURE_NAME = 'BASE_NEXTIVA_CONNECT';

// Pulled in from launchpad-spa src/constants/links.ts
export const MAC_DOWNLOAD_DESKTOP_LINKS = {
  dev:
    'https://storage.googleapis.com/nextivawebsites-misc/Nextiva-development.dmg',
  rc: 'https://storage.googleapis.com/nextivawebsites-misc/Nextiva-rc.dmg',
  production: 'https://assets.nextiva.com/download/Nextiva-mac.dmg',
};

// Pulled in from launchpad-spa src/constants/links.ts
export const WINDOWS_DOWNLOAD_DESKTOP_LINKS = {
  dev:
    'https://storage.googleapis.com/nextivawebsites-misc/Nextiva-development.exe',
  rc: 'https://storage.googleapis.com/nextivawebsites-misc/Nextiva-rc.exe',
  production: 'https://assets.nextiva.com/download/Nextiva-win.exe',
};

// Pulled in from launchpad-spa src/constants/links.ts
export const LINUX_DOWNLOAD_DESKTOP_LINKS = {
  dev:
    'https://storage.googleapis.com/nextivawebsites-misc/Nextiva-development.AppImage',
  rc: 'https://storage.googleapis.com/nextivawebsites-misc/Nextiva-rc.AppImage',
  production: 'https://assets.nextiva.com/download/Nextiva-linux.AppImage',
};

// Pulled in from launchpad-spa src/utils/user.js
export const VOICE_ADMIN_ROLE_NAME = 'Voice Admin';
export const VOICE_ADMIN_ROLE_TYPE = 'ROLE';
export const SUPER_ADMIN_ROLE_TYPE = 'SUPER_ADMIN';

// Pulled in from launchpad-spa src/constants/messageText.ts
export const VOICE_ADMIN_DISABLE_DUETO_BWPATCHING =
  'Voice administration is currently disabled due to maintenance, please try back later.';
export const QUERY_ERROR_MESSAGE = 'Error loading, please try back later.';
